import React from "react";
import { cn } from "@/lib/utils";

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

export default function Logo({ className = "h-12 w-auto", ...props }: LogoProps) {
  // Define base size classes based on the size prop
  // These will be overridden by equivalent classes in the external className prop
  const baseSizeClasses = {
    sm: "h-20 w-auto",
    md: "h-40 w-auto",
    lg: "h-60 w-auto",
    xl: "h-80 w-auto"  // Added an extra large size option
  };

  const baseSizeClass = baseSizeClasses[props.size || "md"];

  // Combine base size class with external className.
  // cn utility intelligently handles overrides based on utility class type.
  const finalClassName = cn(baseSizeClass, className);

  return (
    <div className={`flex items-center`}>
      <img 
        src="/assets/logos/saunadip-logo.svg" 
        alt="SaunaDip Logo" 
        className={finalClassName}
        loading="eager" 
        {...props}
      />
    </div>
  );
}
